import { render, staticRenderFns } from "./GlobalPublishInfo.vue?vue&type=template&id=4fefd1b3&scoped=true&"
import script from "./GlobalPublishInfo.vue?vue&type=script&lang=js&"
export * from "./GlobalPublishInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fefd1b3",
  null
  
)

export default component.exports